import {countries} from './countries'
import {get} from 'lodash'
import messages from './country/messages';
import intl from '../intl';

export const getCountryByCode = (code: string) => {
    const country = get(countries, code);
    if(country) {
        let cleanCountry = country.native.replace(/\s/g, "");
        let formatedCity = get(messages, cleanCountry);
        if(formatedCity) {
           
           return intl.formatMessage(formatedCity)
        }
        
    }
    return null;
}
